import React, { useState } from 'react';
import categories from 'data/can-store/categories';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import CategoryIcon from '@mui/icons-material/Category';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import ExpandMore from '@mui/icons-material/ExpandMore';

function ModernNavBar(): JSX.Element {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const open = Boolean(anchorEl);

	const onOpenCategoryMenu = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const onCloseCategoryMenu = (): void => {
		setAnchorEl(null);
	};

	return (
		<Box
			component="section"
			sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
		>
			<List
				sx={{
					minWidth: '17.5rem',
					padding: '0rem',
					borderRadius: '10px',
					backgroundColor: 'var(--csmd-cl-bg-icon_button)',
				}}
			>
				<ListItemButton onClick={onOpenCategoryMenu}>
					<ListItemIcon sx={{ fontSize: '1.5rem', minWidth: '2.5rem' }}>
						<CategoryIcon />
					</ListItemIcon>
					<ListItemText primary="Category" sx={{ color: 'var(--csmd-cl-text-primary)' }} />
					{open ? <KeyboardArrowRightOutlinedIcon /> : <ExpandMore />}
				</ListItemButton>
			</List>
			<Menu anchorEl={anchorEl} open={open} onClose={onCloseCategoryMenu}>
				{categories.map((category) => (
					<MenuItem key={category.id}>{category.name}</MenuItem>
				))}
			</Menu>
			<Stack direction="row" spacing={1}>
				<Button
					variant="text"
					sx={{ color: 'var(--csmd-cl-text-primary)', textTransform: 'none', fontSize: '1rem' }}
				>
					Best Sellers
				</Button>
				<Divider orientation="vertical" variant="middle" flexItem />
				<Button
					variant="text"
					sx={{ color: 'var(--csmd-cl-text-primary)', textTransform: 'none', fontSize: '1rem' }}
				>
					Thanksgiving
				</Button>
				<Divider orientation="vertical" variant="middle" flexItem />
				<Button
					variant="text"
					sx={{ color: 'var(--csmd-cl-text-primary)', textTransform: 'none', fontSize: '1rem' }}
				>
					5-Start Rated
				</Button>
				<Divider orientation="vertical" variant="middle" flexItem />
				<Button
					variant="text"
					sx={{ color: 'var(--csmd-cl-text-primary)', textTransform: 'none', fontSize: '1rem' }}
				>
					New Arrivals
				</Button>
				<Divider orientation="vertical" variant="middle" flexItem />
				<Button
					variant="text"
					sx={{ color: 'var(--csmd-cl-text-primary)', textTransform: 'none', fontSize: '1rem' }}
				>
					Promotion
				</Button>
			</Stack>
		</Box>
	);
}

export default ModernNavBar;
